module.exports = __webpack_public_path__ + "static/gallery11-e5c3114c690646a194d9860d7d16a21d.jpg";